import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
import { Route, Routes } from "react-router";

import { AuthRoute } from "./auth/AuthRoute";
import { Archiver } from "./components/Archiver";
import { ArchiverLogs } from "./components/ArchiverLogs";
import { Configuration } from "./components/Configuration";
import { FileTree } from "./components/FileTree";
import { Home } from "./components/Home";
import Layout from "./components/Layout.js";
import "./custom.css";
import { Missing } from "./components/Missing";
import { NewSeries } from "./components/NewSeries";
import { SeriesConfiguration } from "./components/SeriesConfigutation";
import { darkTheme } from "./utils/Themes";

const theme = createTheme(darkTheme);

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route
            path="/archiver"
            element={
              <AuthRoute>
                <Archiver />
              </AuthRoute>
            }
          />
          <Route
            path="/file-tree"
            element={
              <AuthRoute>
                <FileTree />
              </AuthRoute>
            }
          />
          <Route
            path="/new-series"
            element={
              <AuthRoute>
                <NewSeries />
              </AuthRoute>
            }
          />
          <Route
            path="/missing-episodes"
            element={
              <AuthRoute>
                <Missing />
              </AuthRoute>
            }
          />
          <Route
            path="/configuration"
            element={
              <AuthRoute>
                <Configuration />
              </AuthRoute>
            }
          />
          <Route
            path="/series-configuration"
            element={
              <AuthRoute>
                <SeriesConfiguration />
              </AuthRoute>
            }
          />
          <Route
            path="/archiver-logs"
            element={
              <AuthRoute>
                <ArchiverLogs />
              </AuthRoute>
            }
          />
        </Routes>
      </Layout>
    </ThemeProvider>
  );
}
